(() => {
  for (const root of document.querySelectorAll('[data-csc-conditions]')) {
    if (root.dataset.initialized) continue;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form[data-conditions-form]');
    // Profile routes replace the general application form. Keep older previews compatible.
    if (!form) continue;
    const texts = JSON.parse(root.querySelector('[data-form-copy]').textContent);
    const result = root.querySelector('[data-form-result]');
    const submit = form.querySelector('[type=submit]');
    let requestId = null;
    const resetErrors = () => {
      for (const el of form.querySelectorAll('[aria-invalid]')) el.removeAttribute('aria-invalid');
      for (const el of form.querySelectorAll('[data-field-error]')) el.textContent = '';
    };
    const showErrors = errors => {
      for (const [name, code] of Object.entries(errors)) {
        const field = form.elements.namedItem(name);
        if (field && field.setAttribute) field.setAttribute('aria-invalid', 'true');
        const target = form.querySelector(`[data-field-error="${name}"]`);
        if (target) target.textContent = texts[`error_${code}`] || texts.error_required;
      }
      form.querySelector('[aria-invalid=true]')?.focus();
    };
    for (const link of root.querySelectorAll('[data-interest]')) link.addEventListener('click', () => {
      const checkbox = form.querySelector(`[name=interests][value="${link.dataset.interest}"]`);
      if (checkbox) checkbox.checked = true;
    });
    form.addEventListener('input', () => { requestId = null; });
    form.addEventListener('submit', async event => {
      event.preventDefault(); resetErrors(); result.hidden = true;
      if (!form.reportValidity()) return;
      const endpoint = root.dataset.endpoint;
      if (!endpoint || (root.dataset.preview === 'true' && new URL(endpoint, location.href).origin !== location.origin)) {
        result.hidden = false; result.classList.add('cs-conditions__notice--error');
        result.querySelector('h3').textContent = texts.error_title;
        result.querySelector('p').textContent = texts.error_text; return;
      }
      const fd = new FormData(form);
      const payload = Object.fromEntries(['club_name','contact_name','email','postal_code','website','message','company_fax'].map(k => [k, fd.get(k) || '']));
      payload.interests = fd.getAll('interests');
      const params = new URLSearchParams(location.search);
      payload.attribution = Object.fromEntries(['utm_source','utm_medium','utm_campaign','utm_content'].map(k => [k, params.get(k) || '']));
      payload.locale = root.dataset.locale;
      requestId ||= crypto.randomUUID();
      submit.disabled = true; submit.textContent = texts.submitting;
      try {
        const response = await fetch(endpoint, { method:'POST', credentials:'omit',
          headers:{'Content-Type':'application/json','Idempotency-Key':requestId}, body:JSON.stringify(payload),
          signal:AbortSignal.timeout(15000) });
        const body = await response.json();
        if (!response.ok || !body.ok) {
          if (body.errors) showErrors(body.errors);
          throw new Error('inquiry_failed');
        }
        result.classList.remove('cs-conditions__notice--error');
        result.querySelector('h3').textContent = texts.success_title;
        result.querySelector('p').textContent = texts.success_text;
        result.hidden = false; result.focus(); form.reset(); requestId = null;
      } catch {
        result.classList.add('cs-conditions__notice--error');
        result.querySelector('h3').textContent = texts.error_title;
        result.querySelector('p').textContent = texts.error_text;
        result.hidden = false;
      } finally { submit.disabled = false; submit.textContent = texts.submit; }
    });
  }
})();
